import { ArrowLeftOutlined, ArrowRightOutlined, ControlOutlined } from '@ant-design/icons';
import { Button, Card, Row } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';

import { impExternalStepUpdated } from '../../../store/impExternal';
import { RowExt } from '../../../styles';
import ImpCard from '../ImpCard';
import ImpCommAutoAssign from '../ImpCommonData/ImpCommAutoAssign';
import ImpCommFactualBasis from '../ImpCommonData/ImpCommFactualBasis';
import ImpCommLegalBasis from '../ImpCommonData/ImpCommLegalBasis';
import ImpCommMaturityOpts from '../ImpCommonData/ImpCommMaturityOpts';
import { IMP_EXTERNAL } from '../ImpCommonData/impCommonData';

const ImportExternalCommData = () => {
  const dispatch = useDispatch();

  const onNext = () => {
    dispatch(impExternalStepUpdated(2));
  };

  const onBack = () => {
    dispatch(impExternalStepUpdated(0));
  };

  return (
    <ImpCard
      icon={<ControlOutlined />}
      {...{
        title: 'Opcje importu',
        desc:' Wybierz wspólne dane importu. Zawsze możesz później skorygować swoją decyzję co do poszczególnych kwot.'
      }}
    >
      <RowExt
        justify="space-between"
        align='middle'
        marginBottom={24}
      >
        <Button
          type="dashed"
          icon={<ArrowLeftOutlined />}
          onClick={onBack}
        />

        <Button
          type="primary"
          icon={<ArrowRightOutlined />}
          onClick={onNext}
        />
      </RowExt>
      <Row>
        <Card
          style={{ width: '100%' }}
        >
          <ImpCommMaturityOpts
            impType={IMP_EXTERNAL}
          />
          <ImpCommLegalBasis
            impType={IMP_EXTERNAL}
          />
          <ImpCommFactualBasis
            impType={IMP_EXTERNAL}
          />
          <ImpCommAutoAssign
            impType={IMP_EXTERNAL}
          />
        </Card>
      </Row>
    </ImpCard>

  );
};

export default ImportExternalCommData;
